import LayoutComposer from './LayoutComposer.js';
import LayoutSingleColumn from './LayoutSingleColumn/LayoutSingleColumn.js';
import LayoutSideNavigation from './LayoutSideNavigation/LayoutSideNavigation.js';

export { LayoutSingleColumn, LayoutSideNavigation };
export default LayoutComposer;
